import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import './Detail.scss';
import common from '../../common'; 

const { useModal } = common();

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Detail({isLogin, openLoginModal}) {

    const { pModal, ModalComponent} = useModal(); // 훅 사용
	const { useAlert, useLoading } = common();
	const { pAlert, AlertComponent } = useAlert();
	const { pLoadingOn, pLoadingOff,LoadingComponent} = useLoading();

    const [detailData, setDetailData] = useState([]);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const idx = queryParams.get('id');

    const formatDateString = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 월은 0부터 시작하므로 1을 더함
        const day = date.getDate().toString().padStart(2, '0');
        
        let formattedDate = `${year}년 ${month}월 ${day}일`;

        const hours = date.getHours();
        const minutes = date.getMinutes();
        if (hours || minutes) { // 시:분이 있는 경우 추가
            const formattedHours = hours.toString().padStart(2, '0');
            const formattedMinutes = minutes.toString().padStart(2, '0');
            formattedDate += ` ${formattedHours}시 ${formattedMinutes}분`;
        }
        
        return formattedDate;
    };
    const setData = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/naek_event/out/get_detail`, { target_idx:idx, il:isLogin }, { withCredentials: true });
        
            if (response && response.data && response.data.result === 't') {
                setDetailData(response.data.data);
            } else {
                console.error(response.data);
                setDetailData([]);
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('실패:', error);
            setDetailData([]);
        } finally {
            setTimeout(() => {
                pLoadingOff();
            }, 100);
        }
    };

    
	const EventRegister = async () => {
        if(isLogin){
            try {
                pLoadingOn();
                const response = await axios.post(`${API_BASE_URL}/naek_event/in/attend_event`, { target_idx:idx }, { withCredentials: true });
                if (response && response.data && response.data.result === 't') {
                    pAlert(response.data.msg);
                    setData();
                } else {
                    pAlert(response.data.msg);
                    console.error(response.data);
                }
            } catch (error) {
                console.error('실패:', error);
            } finally {
                setTimeout(() => {
                    pLoadingOff();
                }, 300);
            }
        } else {
            pAlert('로그인 후 이용하실 수 있습니다.');
        }
    };

    useEffect(() => {
        setData();
    }, [isLogin, idx]);
    






















    const toDateOnly = (value) => {
        if (!value) return null;

        if (typeof value === "string") {
            // "YYYY-MM-DD HH:mm:ss" => "YYYY-MM-DDTHH:mm:ss"
            const normalized = value.replace(" ", "T");
            const d = new Date(normalized);

            if (!Number.isNaN(d.getTime())) {
                return new Date(d.getFullYear(), d.getMonth(), d.getDate());
            }

            // "YYYY-MM-DD" 같은 경우도 대응
            const d2 = new Date(value);
            if (!Number.isNaN(d2.getTime())) {
                return new Date(d2.getFullYear(), d2.getMonth(), d2.getDate());
            }

            return null;
        }

        const d = new Date(value);
        if (Number.isNaN(d.getTime())) return null;

        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    };

    const isBeforeEventDate = (eventStartDate) => {
        const eventDate = toDateOnly(eventStartDate);
        if (!eventDate) return false;

        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const todayOnly = toDateOnly(today);

        // today < eventDate 이면 "행사날짜 이전"..
        return today.getTime() <= eventDate.getTime();
    };

    const bottomBtn = useMemo(() => {
        if (!isLogin) {
            return (
                <button
                    className="p_btn p_btn_normal p_btn_blue event_register_btn"
                    onClick={openLoginModal}
                    type="button"
                >
                    로그인 후 이용하실 수 있습니다
                </button>
            );
        }

        if (!detailData) {
            return null;
        }

        const isAcceptButtonEnabled =
            detailData.acceptStatus === 2 || detailData.acceptStatus === "2";

        const isRegistered =
            detailData.registerStatusIDX === "250101" ||
            detailData.registerStatusIDX === "351101" ||
            detailData.registerStatusIDX === 250101 ||
            detailData.registerStatusIDX === 351101;

        const isAttendYes =
            detailData.attendStatusIDX === "351301" ||
            detailData.attendStatusIDX === 351301;

        const isAttendNo =
            detailData.attendStatusIDX === "351401" ||
            detailData.attendStatusIDX === "351501" ||
            detailData.attendStatusIDX === 351401 ||
            detailData.attendStatusIDX === 351501;

        const beforeEvent = isBeforeEventDate(detailData.startDate);

        if (!isAcceptButtonEnabled) {
            return null;
        }

        if (beforeEvent) {
            if (!isRegistered) {
                return (
                    <button
                        className="p_btn p_btn_normal p_btn_blue event_register_btn"
                        onClick={EventRegister}
                        type="button"
                    >
                        행사 참석 신청
                    </button>
                );
            }

            return (
                <>
                    <span className="p_btn p_btn_normal p_btn_display">참석 신청 완료</span>
                    <div className="f_small event_register_notice">
                        참석 취소를 희망하는 경우 사무처에 문의해주시기 바랍니다.
                    </div>
                </>
            );
        }

        if (!isRegistered) {
            return null;
        }

        if (isAttendYes) {
            return <span className="p_btn p_btn_normal p_btn_display">행사 참석</span>;
        }

        if (isAttendNo) {
            return <span className="p_btn p_btn_normal p_btn_display p_btn_grey">행사 불참</span>;
        }
        return null;
    }, [isLogin, detailData, openLoginModal, EventRegister]);

    return (
        <>
            <AlertComponent />
            <LoadingComponent />
            <ModalComponent />
            <div className="detail_wrap">
                <div className="components_wrap">
                    <div className="p_event_wrap">
                        <div className="event_info_box">
                            <span className="event_title">{detailData.title}</span>
                            <table className='event_table'>
                                <tbody>
                                    <tr>
                                        <th>행사명</th>
                                        <td>{detailData.title}</td>
                                    </tr>
                                    <tr>
                                        <th>행사종류</th>
                                        <td>{detailData.EventCategoryName}</td>
                                    </tr>
                                    {
                                        isLogin && (
                                            <>
                                                <tr>
                                                    <th>행사장소</th>
                                                    <td>{detailData.place}</td>
                                                </tr>
                                                <tr>
                                                    <th>행사일시</th>
                                                    <td>{formatDateString(detailData.startDate)}</td>
                                                </tr>
                                            </>
                                        )
                                    }
                                    {
                                        (
                                            detailData.entryCost === 0
                                            || detailData.entryCost === '0'
                                            || detailData.entryCost === ''
                                            || detailData.entryCost === null) ? (
                                            null
                                        ) : (
                                            <tr>
                                                <th>행사비</th>
                                                <td>{typeof detailData.entryCost === 'number' ? detailData.entryCost.toLocaleString() + ' 원' : detailData.entryCost}</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                            <div className='p_event_detail_content' dangerouslySetInnerHTML={{ __html: detailData.contents }}></div>
                        </div>

                        <div className='event_register_btn_box'>{bottomBtn}</div>
                    </div>
                </div>
            </div>
            
        </>
    );
}

export default Detail;